<template>
    <general-link class="dropdown-item"><slot></slot></general-link>
</template>
